// Order Expanded View Component
import React from 'react';
import { 
  CollapsibleSection, 
  PastCompletedOrdersSection,
  AnusthanScheduleSection,
  BhojDaanScheduleSection,
  AstroAnalysisUploadSection
} from './SharedComponents';
import { BraceletConfigSection, RecommendAnusthanSection } from './BraceletAndRecommendComponents';

// ══════════════════════════════════════════
// ORDER EXPANDED VIEW COMPONENT
// ══════════════════════════════════════════

export const OrderExpandedView = ({ 
  order, 
  anusthans, 
  onUploadAnalysis, 
  onRemoveAnalysis, 
  onUpdateAstroStatus, 
  onSaveBraceletConfig, 
  onSaveRecommendations, 
  onUpdateStatus, 
  onScheduleAnusthan, 
  onScheduleBhojDaan 
}) => {
  // For Astro Analysis orders
  if (order.service_type === 'astro_analysis') {
    return (
      <div style={{ padding: '24px' }}>
        {/* Basic Details Section */}
        <CollapsibleSection
          title="Customer Basic Details"
          icon="📋"
          defaultExpanded={false}
        >
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px' }}>
            <div>
              <label style={{ display: 'block', fontSize: '0.7rem', color: '#725b47', textTransform: 'uppercase', marginBottom: '4px' }}>Customer Name</label>
              <div style={{ fontFamily: 'Lato, sans-serif', fontSize: '1rem', color: '#2E221A', fontWeight: '500' }}>{order.customer_name || '-'}</div>
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '0.7rem', color: '#725b47', textTransform: 'uppercase', marginBottom: '4px' }}>Date of Birth</label>
              <div style={{ fontFamily: 'Lato, sans-serif', fontSize: '1rem', color: '#2E221A' }}>{order.birth_date || '-'}</div>
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '0.7rem', color: '#725b47', textTransform: 'uppercase', marginBottom: '4px' }}>Time of Birth</label>
              <div style={{ fontFamily: 'Lato, sans-serif', fontSize: '1rem', color: '#2E221A' }}>{order.birth_time || '-'}</div>
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '0.7rem', color: '#725b47', textTransform: 'uppercase', marginBottom: '4px' }}>Place of Birth</label>
              <div style={{ fontFamily: 'Lato, sans-serif', fontSize: '1rem', color: '#2E221A' }}>{order.birth_place || '-'}</div>
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '0.7rem', color: '#725b47', textTransform: 'uppercase', marginBottom: '4px' }}>Gotra</label>
              <div style={{ fontFamily: 'Lato, sans-serif', fontSize: '1rem', color: '#2E221A' }}>{order.gotra || '-'}</div>
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '0.7rem', color: '#725b47', textTransform: 'uppercase', marginBottom: '4px' }}>Mobile</label>
              <div style={{ fontFamily: 'Lato, sans-serif', fontSize: '1rem', color: '#2E221A' }}>{order.customer_phone || '-'}</div>
            </div>
          </div>
          {order.question && (
            <div style={{ marginTop: '20px' }}>
              <label style={{ display: 'block', fontSize: '0.7rem', color: '#725b47', textTransform: 'uppercase', marginBottom: '4px' }}>Question Asked</label>
              <div style={{ fontFamily: 'Lato, sans-serif', fontSize: '1rem', color: '#2E221A', background: '#faf8f5', padding: '12px', border: '1px solid #e0d5c5' }}>
                {order.question}
              </div>
            </div>
          )}
        </CollapsibleSection>

        {/* Upload Astro Analysis Document */}
        <AstroAnalysisUploadSection 
          order={order} 
          onUpload={onUploadAnalysis}
          onRemove={onRemoveAnalysis}
          onStatusChange={onUpdateAstroStatus}
        />

        {/* Bracelet Stone Configuration */}
        <BraceletConfigSection 
          order={order} 
          onSave={onSaveBraceletConfig}
          isAnalysisDone={!!order.astro_analysis_file}
        />

        {/* Recommend Anusthan */}
        <RecommendAnusthanSection 
          order={order} 
          anusthans={anusthans} 
          onSave={onSaveRecommendations}
          isAnalysisDone={!!order.astro_analysis_file}
        />

        {/* Past Completed Orders */}
        <PastCompletedOrdersSection 
          customerId={order.customer_id}
          customerPhone={order.customer_phone}
          currentOrderId={order.order_id}
        />
      </div>
    );
  }

  // For Anusthan orders
  if (order.service_type === 'anusthan') {
    return (
      <div style={{ padding: '24px' }}>
        <CollapsibleSection
          title="Anusthan Order Details"
          icon="🪔"
          defaultExpanded={false}
        >
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px' }}>
            <div>
              <label style={{ display: 'block', fontSize: '0.7rem', color: '#725b47', textTransform: 'uppercase', marginBottom: '4px' }}>Customer Name</label>
              <div style={{ fontFamily: 'Lato, sans-serif', fontSize: '1rem', color: '#2E221A', fontWeight: '500' }}>{order.customer_name || '-'}</div>
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '0.7rem', color: '#725b47', textTransform: 'uppercase', marginBottom: '4px' }}>Anusthan</label>
              <div style={{ fontFamily: 'Lato, sans-serif', fontSize: '1rem', color: '#8B4513', fontWeight: '500' }}>{order.anusthan_name || '-'}</div>
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '0.7rem', color: '#725b47', textTransform: 'uppercase', marginBottom: '4px' }}>Package</label>
              <div style={{ fontFamily: 'Lato, sans-serif', fontSize: '1rem', color: '#2E221A' }}>
                {order.package_name || '-'}
                {order.package_price > 0 && <span style={{ marginLeft: '8px', color: '#2E7D32' }}>₹{order.package_price}</span>}
              </div>
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '0.7rem', color: '#725b47', textTransform: 'uppercase', marginBottom: '4px' }}>Mobile</label>
              <div style={{ fontFamily: 'Lato, sans-serif', fontSize: '1rem', color: '#2E221A' }}>{order.customer_phone || '-'}</div>
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '0.7rem', color: '#725b47', textTransform: 'uppercase', marginBottom: '4px' }}>Ceremony Date</label>
              <div style={{ fontFamily: 'Lato, sans-serif', fontSize: '1rem', color: '#2E221A' }}>{order.anusthan_date || '-'}</div>
            </div>
          </div>
        </CollapsibleSection>

        {/* Schedule Anusthan Section */}
        {onScheduleAnusthan && order.status !== 'scheduled' && order.status !== 'completed' && (
          <AnusthanScheduleSection 
            order={order}
            onSchedule={onScheduleAnusthan}
          />
        )}

        {/* Past Completed Orders */}
        <PastCompletedOrdersSection 
          customerId={order.customer_id}
          customerPhone={order.customer_phone}
          currentOrderId={order.order_id}
        />
      </div>
    );
  }

  // For Bhoj & Daan orders
  if (order.service_type === 'bhoj_daan') {
    return (
      <div style={{ padding: '24px' }}>
        <CollapsibleSection
          title="Bhoj & Daan Order Details"
          icon="🙏"
          defaultExpanded={true}
        >
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px' }}>
            <div>
              <label style={{ display: 'block', fontSize: '0.7rem', color: '#725b47', textTransform: 'uppercase', marginBottom: '4px' }}>Customer Name</label>
              <div style={{ fontFamily: 'Lato, sans-serif', fontSize: '1rem', color: '#2E221A', fontWeight: '500' }}>{order.customer_name || '-'}</div>
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '0.7rem', color: '#725b47', textTransform: 'uppercase', marginBottom: '4px' }}>Mobile</label>
              <div style={{ fontFamily: 'Lato, sans-serif', fontSize: '1rem', color: '#2E221A' }}>{order.customer_phone || '-'}</div>
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '0.7rem', color: '#725b47', textTransform: 'uppercase', marginBottom: '4px' }}>Ceremony Date</label>
              <div style={{ fontFamily: 'Lato, sans-serif', fontSize: '1rem', color: '#2E221A' }}>{order.ceremony_date || '-'}</div>
            </div>
            <div>
              <label style={{ display: 'block', fontSize: '0.7rem', color: '#725b47', textTransform: 'uppercase', marginBottom: '4px' }}>Total Amount</label>
              <div style={{ fontFamily: 'Lato, sans-serif', fontSize: '1rem', color: '#2E7D32', fontWeight: '500' }}>₹{((order.amount || 0) / 100).toLocaleString()}</div>
            </div>
          </div>
          
          {/* Selected Seva Types */}
          <div style={{ marginTop: '20px' }}>
            <label style={{ display: 'block', fontSize: '0.7rem', color: '#725b47', textTransform: 'uppercase', marginBottom: '8px' }}>Selected Seva Types</label>
            {order.offerings && order.offerings.length > 0 ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                {order.offerings.map((offering, idx) => (
                  <div key={idx} style={{ padding: '12px 16px', background: '#e0f2f1', borderRadius: '4px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                      <span style={{ fontWeight: '500', color: '#00695C' }}>{offering.offering_name}</span>
                      <span style={{ marginLeft: '12px', fontSize: '0.85rem', color: '#009688' }}>{offering.package_name} ({offering.people} people)</span>
                    </div>
                    <span style={{ fontWeight: '600', color: '#004D40' }}>₹{(offering.price || 0).toLocaleString()}</span>
                  </div>
                ))}
              </div>
            ) : (
              <div style={{ color: '#999' }}>No offerings selected</div>
            )}
          </div>
        </CollapsibleSection>

        {/* Schedule Bhoj & Daan Section */}
        {onScheduleBhojDaan && order.status !== 'scheduled' && order.status !== 'completed' && (
          <BhojDaanScheduleSection 
            order={order}
            onSchedule={onScheduleBhojDaan}
          />
        )}

        {/* Past Completed Orders */}
        <PastCompletedOrdersSection 
          customerId={order.customer_id}
          customerPhone={order.customer_phone}
          currentOrderId={order.order_id}
        />
      </div>
    );
  }

  // Default for other service types
  return (
    <div style={{ padding: '24px' }}>
      <CollapsibleSection
        title="Order Details"
        icon="📋"
        defaultExpanded={false}
      >
        <p style={{ fontFamily: 'Lato, sans-serif', color: '#725b47' }}>
          Service: {order.service_type || 'Unknown'}
        </p>
      </CollapsibleSection>

      {/* Past Completed Orders */}
      <PastCompletedOrdersSection 
        customerId={order.customer_id}
        customerPhone={order.customer_phone}
        currentOrderId={order.order_id}
      />
    </div>
  );
};

export default OrderExpandedView;
